import{Severity as y}from"@sentry/types";import{captureEvent as e,captureException as o,captureMessage as n}from"@sentry/react";var s=(t,r)=>o(t,r),p=t=>e(t),c=t=>n(t),u=()=>({reportError:s,reportMessage:c,reportEvent:p});export{y as Severity,u as useSentry};
//# sourceMappingURL=index.js.map
